import { BaseAlgorithmTuner } from './BaseTuner';
import * as DT from '../DataTypes';
import * as THREE from 'three';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';

export class PlaneTuner {
  private readonly _tuner: BaseAlgorithmTuner<DT.PlaneT, DT.Plane>;

  protected _planningAlgorithm: PlanningAlgorithm;

  public constructor(planningAlgorithm: PlanningAlgorithm) {
    this._tuner = new BaseAlgorithmTuner<DT.PlaneT, DT.Plane>(planningAlgorithm, DT.Plane);
    this._planningAlgorithm = planningAlgorithm;
  }

  public getValue(name: string): {
    normal: THREE.Vector3;
    origin: THREE.Vector3;
  } {
    const plane = this._tuner.getValue(name);
    return {
      normal: plane.planeEq.normal,
      origin: plane.origin
    };
  }

  public setValueAsync(name: string, normal: THREE.Vector3, origin: THREE.Vector3): Promise<void> {
    const planeEq = new THREE.Plane().setFromNormalAndCoplanarPoint(normal.clone().normalize(), origin);
    return this._tuner.setValueAsync(name, {
      planeEq: planeEq,
      origin: origin.clone()
    });
  }

  public getShiftRange(name: string): THREE.Line3 {
    return this._planningAlgorithm.getValueStrict(name + '.shift_range', DT.Line).value;
  }
}
